import { Grid2, Typography } from "@mui/material";
import moment from "moment/moment";
import { relationshipEnumMap } from "../enum/formEnum";

const ClientInfoDetail = ({ formData, fromReview = false }) => {
  return (
    <>
      <Typography variant="h4" color="default.main">
        Form Submission Details
      </Typography>
      {!fromReview && (
        <Typography variant="body1" color="default.light">
          Let us know who is filling out this form
        </Typography>
      )}

      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            City
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.city || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Community Liaison
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.communityLiaison || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Are you filling out this form for someone else?
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.isFillingForSomeoneElse || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Who is filling out this form?
          </Typography>
          <Typography variant="body1" color="default.light">
            {relationshipEnumMap[formData?.formSubmissionDetails.fillerIdentity] || "Self"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Filler's First Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.fillersFirstName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Filler's Last Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.fillersLastName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Filler's Phone
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.fillersPhone || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Email Address
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.email || "-"}
          </Typography>
        </Grid2>
        <Grid2 xs={12}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Please list who referred you to Cambridge Caregivers
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.formSubmissionDetails?.referralSource || "-"}
          </Typography>
        </Grid2>
      </Grid2>

      {/* Client Information */}
      <Typography variant="h4" color="default.main" mt={4.5}>
        Client Information
      </Typography>
      {!fromReview && (
        <Typography variant="body1" color="default.light">
          Enter the basic details about the client who needs care
        </Typography>
      )}
      <Grid2 container spacing={3} mt={3}>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            First Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.firstName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Last Name
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.lastName || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 4 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Date of Birth
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.dateOfBirth
              ? moment(formData.clientInformation.dateOfBirth).format(
                "MM/DD/YYYY"
              )
              : "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 3 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Gender
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.gender || "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 3 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Height (Feet)
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.heightFeet ?? "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 3 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Height (Inches)
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.heightInches ?? "-"}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 6, sm: 3 }}>
          <Typography variant="body2" color="default.main" mb={0.5}>
            Weight (lbs)
          </Typography>
          <Typography variant="body1" color="default.light">
            {formData?.clientInformation?.weight ?? "-"}
          </Typography>
        </Grid2>
      </Grid2>
    </>
  );
};
export default ClientInfoDetail;
